import { cloneElement } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/swiper.min.css';
import 'swiper/components/effect-coverflow/effect-coverflow.min.css';
import 'swiper/components/pagination/pagination.min.css';

// import Swiper core and required modules
import SwiperCore, { EffectCoverflow, Navigation, Autoplay } from 'swiper/core';

// install Swiper modules
SwiperCore.use([EffectCoverflow, Navigation, Autoplay]);

export default function SwiperSlider({ children }) {
  let theChildren = null;
  let childrenCleaned = [];

  if (children) {
    childrenCleaned = [];
    theChildren = children.map((child) => {
      const theChild = child;
      if (theChild.props.className) {
        childrenCleaned.push(
          cloneElement(theChild, {
            ...theChild.props,
            className: theChild.props.className + ' swiper-slide',
          })
        );
      } else {
        childrenCleaned.push(
          cloneElement(theChild, {
            ...theChild.props,
            className: 'swiper-slide',
          })
        );
      }

      return theChild;
    });
  }
  return (
    <>
      <Swiper
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        grabCursor
        loop
        navigation={{
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }}
        preventClicks={false}
        slidesPerView="auto"
      >
        <div className="swiper-slider swiper-container">
          <div className="swiper-wrapper">
            {theChildren.map((child, index) => (
              <SwiperSlide key={index}>{child}</SwiperSlide>
            ))}
          </div>
        </div>
      </Swiper>
      <div className="col-xs-12">
        <div className="swiper-button-prev">
          <img alt="arrow left" src="/img/offers/arrow-left.svg" />
        </div>
        <div className="swiper-button-next">
          <img alt="arrow right" src="/img/offers/arrow-right.svg" />
        </div>
      </div>
    </>
  );
}
